
import React, { useState } from 'react'
import { useAppDispatch } from '../../../hooks/redux'
import { setMyDraftUnitsOpen } from '../../../store/slices/unitsSlice'

import { useNavigate } from 'react-router-dom'
import UseUserType from '../../../hooks/UseUserType'
import { Upload } from 'antd'
import { scanDocument } from '../../../store/actionsCreators/documentsActions/scaning/documentScan'
import { dataFetchingFinish } from '../../../store/slices/modalSlice'
import { swalError, swalSuccess } from '../../../functions/swalOptions'
import { getErrorss, getMessageForError } from '../../../functions/errors/GetErrors'

export default function PathHowCreateUnit(): JSX.Element {

    const [loadingLocal, setLoadingLocal] = useState(false)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const { userTypeLowercase } = UseUserType()



    const scanHandler = async (selectedFile: any): Promise<void> => {
        if (!selectedFile) return;
        setLoadingLocal(true);
        try {
            const scanDoc = await dispatch(scanDocument({ agent_create_unit_title_deed: [selectedFile] } as any));
            if (scanDoc && scanDoc.document) {

                // const jsonCreatedUnit = await dispatch(createDraftUnit({ agent_create_unit_title_deed: selectedFile }))

                // if (jsonCreatedUnit.isSuccessful) {

                //     await swalSuccess(jsonCreatedUnit.textNotification, () => {

                //         setLoadingLocal(false);
                //         dispatch(setMyDraftUnitsOpen(true))
                //         navigate(jsonCreatedUnit.textNavigate)
                //     })
                // } else {
                //     await swalError(jsonCreatedUnit.textNotification)
                // }
            } else {
                await swalError(getErrorss(getMessageForError("The document was not recognized properly" + "<br/><strong>Try again</strong>")))
            }
            setLoadingLocal(false);
        } catch (error) {
            console.error('Error while scanning title deed:', error);
            setLoadingLocal(false);
        } finally {
            dispatch(dataFetchingFinish());
        }
    };


    return (

        <>




            <div className="d-flex flex-column gap-4 w-100 scrollbar-width overflow-x-auto px-4 mb-4">
                <div className={'col'} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                    <Upload
                        className="customSizedUpload"
                        name="avatar"
                        listType="picture-card"
                        showUploadList={false}
                        customRequest={async ({ file, onSuccess, onError }) => {
                            setLoadingLocal(true);
                            try {
                                await scanHandler(file);
                            } catch (error) {
                                console.error('Error while scanning title deed:', error);
                            } finally {
                                setLoadingLocal(false);
                            }
                        }}

                    >
                        <button style={{ border: 0, background: 'none' }} type="button">
                            {loadingLocal ? (
                                <i className="fs-5hx fs-lg-4hx text-dark las la-spinner la-spin"></i>
                            ) : (
                                <i className="fs-5hx fs-lg-4hx text-dark las la-plus-circle"></i>
                            )}
                            <div className="d-flex align-items-center justify-content-center w-100 px-auto py-n1 overlay">
                                <span className={`fs-6 text-dark text-uppercase my-2 pb-2 lh-1 text-center`}>
                                    By Scan Title Deed
                                </span>
                            </div>
                        </button>
                    </Upload>
                </div>

                <div className={'col'} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: "calc(100% - 1px)" }} onClick={() => { navigate(`/${userTypeLowercase}/modal/agent_create_unit_property/-/-`) }}>
                    <div className={`bg-gray-100 border-gray-300 border border-1 d-flex flex-column align-items-center  overflow-hidden rounded-3 py-5`} style={{ width: "100%", }}>
                        <i className="fs-5hx fs-lg-4hx text-dark las la-marker"></i>
                        <div className={'d-flex align-items-center justify-content-center w-100 px-auto py-n1 overlay'}>
                            <span className={`fs-6 text-dark text-uppercase my-2 pb-2 lh-1 text-center`}>
                                By Manually
                            </span>
                        </div>
                    </div>
                </div>
            </div >

            <div className="separator separator-dashed my-4"></div>

            {
                <p className={'text-gray-800 fs-7 text-uppercase lh-sm '}>
                    Boost your listing’s exposure and enhance your chances of closing a deal by verifying
                    your property. Simply scan your title deed by taking a picture or uploading a picture of
                    the document.
                </p>
            }
        </>

    )
}
